/** 网络、接口 相关配置 **/
export const axiosConfig = {
  // common
  HTTP_CODE: {
    SUCCESS: 200,
    UNAUTHORIZED: 401,
  },

  STATUS_CODE: {
    SUCCESS: 200,
    SERVER_ERR: 503,
  },
};
